//@flow
import { List } from 'immutable';
import {
    LOAD_MODELS_DETAILS,
    LOAD_MODELS_DETAILS_SUCCESS,
    LOAD_MODELS_DETAILS_FAIL,
    SET_SELECTED_MODEL_INDEX,
    DELETE_MODEL,
    DELETE_MODEL_SUCCESS,
    DELETE_MODEL_FAIL,
    CLEAR_ERROR,
    SELECT_MODEL,
    MODELS_DETAILS,
  } from './../types/model';
  import type { ModelDetail } from './../types/model';
  
  export type ModelAction = {
    type: string,
    axiosInstance?: Object,
    projectId?: Number,
    error?: string,
    index?: number,
    modelsDetails?: List<ModelDetail>,
    selectedIndex?: Number,
    modelId?: Number,
  };

  export const loadModelsDetails = (axiosInstance: any, id: number): ModelAction => ({
    type: LOAD_MODELS_DETAILS,
    id,
    axiosInstance,
  });
  
  export const loadModelsDetailsSuccess = (modelsDetails: Array<ModelDetail>): ModelAction => ({
    type: LOAD_MODELS_DETAILS_SUCCESS,
    [MODELS_DETAILS]: modelsDetails
  });
  
  export const loadModelsDetailsFail = (error: string): ModelAction => ({
    type: LOAD_MODELS_DETAILS_FAIL,
    error
  });

  export const setSelectedModelIndex = (index: number) =>({
    type: SET_SELECTED_MODEL_INDEX,
    index
  });
  
  export const deleteModel = (axiosInstance: Object, modelId: Number): ModelAction => ({
    type: DELETE_MODEL,
    modelId,
    axiosInstance,
  });
  
  export const deleteModelSuccess = (modelId: number): ModelAction => ({
    type: DELETE_MODEL_SUCCESS,
    modelId
  });
  
  export const deleteModelFails = (error: string): ModelAction => ({
    type: DELETE_MODEL_FAIL,
    error
  });
  
  export const clearError = (error: string)=>({
    type: CLEAR_ERROR,
  });

  export const selectModel = (modelId: Number) => ({
    type: SELECT_MODEL,
    modelId,
  });


// WEBPACK FOOTER //
// ./src/actions/model.jsx